import { css, createGlobalStyle } from 'styled-components';

const h1 = css`
  /* Heading 1 */
  font-family: 'Pretendard Variable';
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: 40px;
`;
const subtitle1 = css`
  /* Subtitle 1 */
  font-family: 'Pretendard Variable';
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 30px;
`;
const subtitle2 = css`
  /* Subtitle 2 */
  font-family: 'Pretendard Variable';
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px; /* 155.556% */
`;
const subtitle3 = css`
  /* Subtitle 3 */
  font-family: 'Pretendard Variable';
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 28px; /* 155.556% */
`;

const body1 = css`
  /* Body 1 */
  font-family: 'Pretendard Variable';
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */
`;

const body2 = css`
  /* Body 2 */
  font-family: 'Pretendard Variable';
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px; /* 150% */
`;

const body3 = css`
  /* Body 3 */
  font-family: 'Pretendard Variable';
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px; /* 150% */
`;

const body4 = css`
  /* Body 4 */
  font-family: 'Pretendard Variable';
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
`;

const body5 = css`
  /* Body 5 */
  font-family: 'Pretendard Variable';
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 142.857% */
`;

const body6 = css`
  /* Body 6 */
  font-family: 'Pretendard Variable';
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px; /* 142.857% */
`;

const caption1 = css`
  /* Caption 1 */
  font-family: 'Pretendard Variable';
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 150% */
`;

const caption2 = css`
  /* Caption 2 */
  font-family: 'Pretendard Variable';
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px; /* 150% */
`;

const caption3 = css`
  /* Caption 3 */
  font-family: 'Pretendard Variable';
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 18px; /* 150% */
`;

const caption4 = css`
  /* Caption 4 */
  font-family: 'Pretendard Variable';
  font-size: 10px;
  font-style: normal;
  font-weight: 500;
  line-height: 12px; /* 120% */
`;

const typescales = {
  h1,
  subtitle1,
  subtitle2,
  subtitle3,
  body1,
  body2,
  body3,
  body4,
  body5,
  body6,
  caption1,
  caption2,
  caption3,
  caption4,
} as const;
export type Typescales = keyof typeof typescales;
export default typescales;

export const GlobalTypeScaleStyle = createGlobalStyle`
  .typo--h1 {
    ${h1};
  }
  .typo--subtitle1 {
    ${subtitle1};
  }
  .typo--subtitle2 {
    ${subtitle2};
  }
  .typo--subtitle3 {
    ${subtitle3};
  }
  .typo--body1 {
    ${body1};
  }
  .typo--body2 {
    ${body2};
  }
  .typo--body3 {
    ${body3};
  }
  .typo--body4 {
    ${body4};
  }
  .typo--body5 {
    ${body5};
  }
  .typo--body6 {
    ${body6};
  }
  .typo--caption1 {
    ${caption1};
  }
  .typo--caption2 {
    ${caption2};
  }
  .typo--caption3 {
    ${caption3};
  }
  .typo--caption4 {
    ${caption4};
  }
`;
